import { cn } from '@/src/core/utils/cn'
import { forwardRef } from 'react'

export interface InputProperties extends React.InputHTMLAttributes<HTMLInputElement> {
	variant?: 'default' | 'currency'
	error?: boolean
	leftAddon?: React.ReactNode
	rightAddon?: React.ReactNode
}

export const Input = forwardRef<HTMLInputElement, InputProperties>(
	({ className, variant = 'default', error, leftAddon, rightAddon, ...properties }, reference) => {
		const baseClasses = cn(
			'block w-full rounded-md border-0 bg-white/5 text-white caret-[#66d697] transition-colors',
			'placeholder:text-white/30 focus:bg-white/10 focus:outline-none focus:ring-2 focus:ring-[#66d697] focus:ring-offset-2 focus:ring-offset-black',
			error && 'ring-2 ring-red-500 focus:ring-red-500',
			variant === 'currency' ? 'h-14 text-center text-3xl px-20 sm:text-4xl' : 'px-3 py-2 text-sm',
			className
		)

		if (leftAddon || rightAddon) {
			return (
				<div className="relative flex items-center">
					{leftAddon ? (
						<div className="absolute inset-y-0 left-0 flex items-stretch">{leftAddon}</div>
					) : undefined}
					<input className={baseClasses} ref={reference} {...properties} />
					{rightAddon ? (
						<div className="absolute inset-y-0 right-0 flex items-stretch">{rightAddon}</div>
					) : undefined}
				</div>
			)
		}

		return <input className={baseClasses} ref={reference} {...properties} />
	}
)

Input.displayName = 'Input'
